import React from 'react';
import { InfoCircleFill } from 'react-bootstrap-icons';
import { useDispatch } from 'react-redux';

import CompanyIcon from '../CompanyIcon';
import { PropertyMarkdown } from '../ProductProperties/PropertyMarkdown';
import UpcomingChangeIcon from '../ProductProperties/UpcomingChangeIcon';

import { Label } from '../../../../../Interface/Response/Interest/Label';
import { ProductProperty } from '../../../../../Interface/Response/Interest/PropertiesPerLabel';
import { UpcomingChange } from '../../../../../Interface/Response/Interest/PropertyAttributes';

import { modalRequested } from '../../../../../Store/Modal/action';

export interface Props {
    expanded?: boolean;
    info?: string;
    viisiNote?: string;
    label?: Label;
    property?: ProductProperty;
    upcomingChange?: UpcomingChange;
}

export const Info: React.FC<Props> = props => {
    const { expanded, info, viisiNote, label, property, upcomingChange } = props;
    const dispatch = useDispatch();

    const handleClick = (): void => {
        dispatch(modalRequested(
            null,
            <PropertyMarkdown info={info} viisiNote={viisiNote} />,
            <>
                Informatie
                {label && (
                    <div className="h6 mb-0">
                        <CompanyIcon finDataCode={label.findataCode} />
                        <small>{label.label}</small>
                    </div>
                )}
                {property && (
                    <div className="h6 mb-0">
                        <small>{property.name}</small>
                    </div>
                )}
            </>
        ));
    };

    if (expanded) {
        return <>
            {(info !== undefined || viisiNote !== undefined) && (
                <div className="property-property__cell__info-only">
                    <PropertyMarkdown info={info} viisiNote={viisiNote} />
                </div>
            )}
            {upcomingChange !== undefined && (
                <div className="property-property__cell__info">
                    <UpcomingChangeIcon change={upcomingChange} />
                </div>
            )}
        </>;
    }

    return (
        <div className="property-property__cell__info">
            <InfoCircleFill data-testid="info-icon" onClick={handleClick} />
            {upcomingChange !== undefined && <UpcomingChangeIcon change={upcomingChange} />}
        </div>
    );
};
